import { BonusSettlementsOverviewApi } from '../overview/api/bonus-settlements-overview-api';
import { BonusSettlementsSupplierDetailApi } from '../supplier-detail/api/bonus-settlements-supplier-detail-api';
import { BonusSettlementsSupplierOverviewApi } from '../detail/api/bonus-settlements-supplier-overview-api';

export class BonusSettlementsApi {
    constructor(protected baseUrl: string) {
        this.BonusSettlementsOverview = new BonusSettlementsOverviewApi(this.baseUrl);
        this.BonusSettlementsSupplierOverview = new BonusSettlementsSupplierOverviewApi(this.baseUrl);
        this.BonusSettlementsSupplierDetail = new BonusSettlementsSupplierDetailApi(this.baseUrl);
    }

    public BonusSettlementsOverview: BonusSettlementsOverviewApi;
    public BonusSettlementsSupplierOverview: BonusSettlementsSupplierOverviewApi;
    public BonusSettlementsSupplierDetail: BonusSettlementsSupplierDetailApi;
}
